/* eslint-disable no-useless-catch */
import { serialize } from '../utils';
import { FindOneOptions, FindOptions } from './common';
import { entityService } from './services';
// #endregion Local Imports

const pathname = '/digital-menu-category-proposal-items';

export const DigitalMenuCategoryProposalItemApi = {
  find: async (option: FindOptions) => {
    let url = pathname;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  findProposalItemsForMenuCategory: async (
    digitalMenuCategoryID: string,
    option: FindProposalItemsForMenuCategoryOption
  ) => {
    let url = `${pathname}/category/${digitalMenuCategoryID}`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  create: async (body: any) => {
    try {
      const response = await entityService.post(pathname, body);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  createMulti: async (body: any) => {
    try {
      const response = await entityService.post(`${pathname}/multi`, body);

      return response.data;
    } catch (error) {
      throw error;
    }
  },

  update: async (id: string, body: any = {}) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  delete: async (id: string, body: any = {}) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.delete(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  deleteMulti: async (body: any) => {
    const url = `${pathname}/delete/multi`;

    try {
      const response = await entityService.post(url, body);

      return response.data;
    } catch (error) {
      throw error;
    }
  },

  updateStatus: async (id: string, body: any = {}) => {
    const url = `${pathname}/update-status/${id}`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },
};

export interface FindProposalItemsForMenuCategoryOption {
  page: number;
  take: number;
  reserved?: boolean;
  name?: string;
}
